import React, { forwardRef, type ReactNode } from 'react';

import { useReducedMotion } from 'framer-motion';

import { StyledButtonIndicator } from '@pkg/components/Sections/Profile/Buttons/Button/styles';
import { Indicator } from '@pkg/components/Sections/Profile/Indicator';

import { type ButtonBaseProps, Colors } from '../ButtonBase';

import { Pulse } from './Pulse';
import { type Size, Sizes } from './types';

import { ButtonIconStyled } from './styles';

type ButtonIconProps = ButtonBaseProps & {
    size?: Size;
    children: ReactNode;
    pulse?: boolean;
};

export const ButtonIcon = forwardRef(
    ({ size = Sizes.medium, pulse, children, indicatorValue, ...rest }: ButtonIconProps, forwardedRef) => {
        const shouldReduceMotion = useReducedMotion();
        const indicator = indicatorValue && (
            <StyledButtonIndicator>
                <Indicator value={indicatorValue} />
            </StyledButtonIndicator>
        );

        return (
            <ButtonIconStyled ref={forwardedRef} $size={size} $color={rest.color || Colors.primary} {...rest}>
                {children}
                {pulse && !shouldReduceMotion && !rest.disabled ? <Pulse responsive total={3} show={true} /> : null}
                {indicator}
            </ButtonIconStyled>
        );
    },
);

ButtonIcon.displayName = 'ButtonIcon';
